var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":"","justify":"center","align":"start"}},[_c('div',{staticClass:"ml-6 mr-6 n-container"},[_c('new-ticket')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }